// MUST be the first import — disables Zod 4.x's JIT validator compiler
// before any schema-using module is imported. apps/compatibility aliases
// @frontend → frontend/src and pulls in hooks like useSessions /
// useStreamingChat that transitively register schemas. Without this line,
// Safari's JSC rejects the JIT-generated validator bodies with
// "Unexpected token '{'" at every parse() call. See
// frontend/src/zod-config.ts for the full rationale. (The same Safari bug
// is why the old Compat SPA was retired — keep this import first.)
import '@frontend/zod-config'

// Side-effect import: initialises the shared i18next instance (de/fr/en)
// used by every @frontend hook and component this app reuses.
import '@frontend/i18n'

import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import '@frontend/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
